/**
 * Creates the store for the appearance (light / dark theme).
 *
 * @param {import('alpinejs').Alpine} Alpine The alpine instance.
 */
export default function (Alpine) {
  // Detect system preference on first load
  const getSystemTheme = () => {
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  };

  // Get stored theme or default to light mode
  const getInitialTheme = () => {
    const stored = localStorage.getItem('theme');
    return stored ? JSON.parse(stored) : 'light';
  };

  Alpine.store("appearance", {
    theme: Alpine.$persist(getInitialTheme()).as("theme"),

    toggle() {
      this.theme = this.theme === 'light' ? 'dark' : 'light';
    },

    init() {
      Alpine.effect(() => {
        const root = document.documentElement;
        root.setAttribute("data-no-transition", "");
        root.setAttribute("data-theme", this.theme);
        setTimeout(() => root.removeAttribute("data-no-transition"));
      });
    },
  });
}
